let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aUfCR")).then(() => parcelRequire('4wLiD'));